import type { LovCxpiDTO } from '@/features/api/extranet/dto/Demande/CXPI'
import type { DemandeStore } from '@/features/interface/demande/shared'
import { storeToRefs } from 'pinia'
import { watch, type InjectionKey } from 'vue'

type InterruptionActions = ReturnType<typeof useInterruptionsActions>
export const CXPI_INTERRUPTIONS_ACTIONS: InjectionKey<InterruptionActions> = Symbol()

export function useInterruptionsActions(
  store: DemandeStore<'MODEL_CXPI', LovCxpiDTO>,
) {
  const { setupCustomUpdater } = store
  const { model } = storeToRefs(store)

  const ajouterInterruption = setupCustomUpdater((patch) => {
    if (!patch.contrat!.interruption) patch.contrat!.interruption = []

    patch.contrat!.interruption!.push({
      dateDebutInterruption: null,
      dateFinInterruption: null,
    })
  })

  const supprimerInterruption = setupCustomUpdater<number>((patch, index) => {
    patch.contrat!.interruption!.splice(index, 1)
  })

  // Periode Interruption
  const updateInterruption = setupCustomUpdater((patch) => {
    patch.contrat!.interruption = []
  })

  watch(
    () => model.value?.contrat?.periodeInterruption,
    () => {
      updateInterruption(null)
      if (model.value?.contrat?.periodeInterruption) ajouterInterruption(null)
    },
  )

  return {
    ajouterInterruption,
    supprimerInterruption,
  }
}
